import { createFileRoute } from '@tanstack/react-router';
import { PageTitle } from '@trukt/ui/PageTitle';
import { SidebarLayout } from '@trukt/ui/SidebarLayout';
import { SidebarContainer } from '@components/pages/components';
import { validateOrderListSearch } from './-order-list-route';

export const Route = createFileRoute('/_order-list')({
  validateSearch: validateOrderListSearch,
  component: OrderListLayout,
});

function OrderListLayout() {
  return (
    <PageTitle>
      <SidebarLayout sidebar={<SidebarContainer />} />
    </PageTitle>
  );
}
